import React from 'react';

import { getTimeFilterOptions, TimeOption } from '../types';

import { useTranslation } from 'app/lang';
import Dropdown, { ChangeHandler } from 'app/widgets/Dropdown/Single';

type FilterByTimeProps = {
  value: TimeOption;
  className: string;
  onChange: ChangeHandler<TimeOption>;
};

const FilterByTime: React.FC<FilterByTimeProps> = ({
  value,
  className,
  onChange,
}) => {
  const { t } = useTranslation();
  const timeFilterOptions = getTimeFilterOptions(t);

  return (
    <Dropdown<TimeOption> value={value}
                          openMenuOnFocus
                          className={className}
                          isSearchable={false}
                          options={timeFilterOptions}
                          onChange={onChange} />
  );
};

export default FilterByTime;
